module.exports = __webpack_public_path__ + "img/list_Portrait_06.8e874e15.jpeg";